import { Controller } from "stimulus"

export default class extends Controller
  @targets: ["defaultField"]

  updateDefault: (event) ->
    for field in @defaultFieldTargets
      field.checked = false unless field == event.target